import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import styled from 'styled-components';

export const TopUpButton = styled(BaseButton)`
  &.ant-btn-background-ghost {
    color: ${({ theme }) => theme.textSecondary};
  }
`;
